<template>
	<div>
		<core-layout-headline-with-tabs :tabs="tabs">
			{{ $t("resource") }}
		</core-layout-headline-with-tabs>
		<core-layout-content full>
			<!-- Language selector -->
			<div class="xs-4 mb4" v-if="$store.state.settings.allowedLocales">
				<div class="pr2 xs-12 fs3 lh125 fw7 pb1">{{ $t("language") }}</div>
				<core-select-locale
					class="xs-12"
					size="xsmall"
					v-model="selectedLocale"
				/>
			</div>

			<!-- Spinner -->
			<div v-if="isLoading" class="xs-12 flex xs-middle xs-center p4">
				<j-spinner />
			</div>

			<!-- Credentials-->
			<resource-detail-credentials
				:resource="resource"
				:selectedLocale="selectedLocale"
				@resource:updated="fetchResource"
			/>
		</core-layout-content>
	</div>
</template>

<script>
/*
 * Read resources/readme.md to understand why we use courses API and what are the differences with Education module
 */
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreSelectLocale from "@/modules/core/components/CoreSelectLocale"
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"
import ResourceDetailCredentials from "../components/ResourceDetailCredentials"
import JSpinner from "@/components/JSpinner"

import api from "@/api/gql.js"
import { i18n } from "@/locales/setup.js"
import queries from "../utils/queries.js"

export default {
	props: {
		id: String
	},

	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineWithTabs,
		ResourceDetailCredentials,
		CoreSelectLocale,
		JSpinner
	},

	data() {
		return {
			resource: null,
			selectedLocale: i18n.locale,
			tabs: [
				{
					id: "overview",
					name: this.$t("overview"),
					to: { name: "ResourceDetail", params: { ...this.$route.params } }
				},
				{
					id: "content",
					name: this.$t("content"),
					to: {
						name: "ResourceContent",
						params: { ...this.$route.params }
					}
				}
			]
		}
	},

	methods: {
		async fetchResource() {
			this.isLoading = true
			const res = await api({
				locale: this.selectedLocale,
				query: queries.fetchCourse,
				variables: {
					where: { id: this.id }
				}
			})
			this.isLoading = false

			// Check errors
			if (res.errors && res?.errors?.length)
				this.$store.dispatch("showError", [res.errors?.[0]?.message])

			this.resource = res?.data?.courses?.list[0]
		}
	},

	created() {
		this.fetchResource()
	},

	watch: {
		selectedLocale: {
			handler(o, n) {
				if (o && n) {
					this.fetchResource()
				}
			}
		}
	}
}
</script>
